import axios from 'axios';
import toastr from 'toastr';
import router from '../router';
import store from '../store';

class Api {

	constructor() {
		//Create the base service
		let service = axios.create({});

		//Set the access token
		service.interceptors.request.use((config) => {
			//Set the token
			config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('app_token');

			//Set form data to enable files
			config.headers.common['Content-Type'] = 'multipart/form-data';

			//Return ti
			return config;
		});

		//Set the default handler for errors
		service.interceptors.response.use(null, function(error) {
			//Handle the error status
			switch(error.response.status)
			{
				//Unauthorized
				case 401:
					//Remove the token from storage
					localStorage.removeItem('app_token');

					//Send to logout
					window.location = process.env.MIX_BASE_URL + '/Logout';

					//Redirect to login
                    //router.push('login');

                    //Push the the main session page. We do this so
                    //We can support single sign on drivers
                    //window.location = process.env.MIX_BASE_LOGIN;
					break;

				case 403: //Permission Issue
					//Push to the store
					if(error.response.data)
					{
						//Testing
						store.commit('setPermissionsRequired', error.response.data);
					}

					//Send to not found
					router.push('/403');
					break;

				case 404:
					//Alert the user? Or redirect

					//Check the Data
					if(error.response.data !== 'File Not Found')
					{
						//Send to not found
						router.push(`/404?intended=${window.location.pathname.replace(/\//gi, '_')}`);
					}
					break;

				case 409:
					//This is the Inactive Account Handler

					//Send to billing page ONLY if not already on the billing page
					if(router.currentRoute.path !== '/billing')
					{
						router.push('/account-suspended');
					}
					break;

				case 418:
					//Send it
					toastr.error(error.response.data);

					//Stop here
					//return;
					break;
				case 422:
					//Validation Error Happened
					toastr.error('Validation Errors Occurred. Check Required Fields.');
					break;
				case 500:
					//Send it
					toastr.error(error.response.data, 'Something Went Wrong');
					break;
			}

			//Return default promise
			return Promise.reject(error);
		});

		//Bind the service to this
		this.service = service;

		//Set the base url
		//this.baseUrl = '/api/v1/';
		this.baseUrl = process.env.MIX_BASE_API;
	}

	base(){
		return this.baseUrl;
	}

	cleanPath(path){
		//This trims any prefixed forward slashes
		if(path.substring(0, 1) === '/')
		{
			return path.substring(1);
		}

		//Return the path
		return path;
	}

	get(path, payload) {
		//Returns the promise
		return this.service.get(this.baseUrl + '/' + this.cleanPath(path), {params: payload});
	}

	getWeb(path, payload) {
		//Returns the promise
		return this.service.get('/' + this.cleanPath(path), {params: payload});
	}

	patch(path, payload, callback) {
		//Return the promise
		return this.service.request({
			method: 'PATCH',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		})
		.then((response) => callback(response.status, response.data));
	}

	post(path, payload) {
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	postWeb(path, payload) {
		return this.service.request({
			method: 'POST',
			url: `/${this.cleanPath(path)}`,
			responseType: 'json',
			data: payload
		});
	}

	postWithFiles(path, payload, files) {
		// //Creat the new formData
		// var formData = new FormData();

		// //Loop and append
		// Object.keys(payload).forEach(function(key) {
		// 	//Check the value for the NULL string
		// 	if(payload[key] == null)
		// 	{
		// 		//Skip? Or append ""
		// 		return; //This is the equivalent of continue;
		// 	}

		// 	//Append
		// 	formData.append(key, payload[key]);
		// });
		var formData = this.convertModelToFormData(payload);

		//Check for an array
		if(Array.isArray(files))
		{
			//Set the data
			for( var i = 0; i < files.length; i++ )
			{
				//Set the files
				let file = files[i];

				//Check for another Array
				if(Array.isArray(file))
				{
					for (var j = 0; j < file.length; j++)
					{
						//Append
						formData.append('files[' + i + ']['+j+']', file[j]);
					}
				}
				else
				{
					//Append
					formData.append('files[' + i + ']', file);
				}
			}
		}
		else
		{
			//Setup keys
			var keys = Object.keys(files);

			//Loop through and build lists
			for(var i = 0; i < keys.length; i++)
			{
			    //Steup
			    let file = files[keys[i]];

			    //Check for another Array
			    if(Array.isArray(file))
			    {
			    	for (var j = 0; j < file.length; j++)
			    	{
			    		//Append
			    		formData.append(keys[i]+'['+j+']', file[j]);
			    	}
			    }
			    else
			    {
			    	//Append
			    	formData.append(keys[i], file);
			    }
			}
		}

		//Send it
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: formData
		});
	}

	postWithSingleFile(path, payload, file, file_key_name = 'file') {
		var formData = this.convertModelToFormData(payload);

		if (file)
		{
        	//Setup
        	var key = file_key_name ? file_key_name : 'file';

        	//Append
        	formData.append(file_key_name, file);
		}

		//Send it
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: formData
		});
	}

	delete(path, payload) {
		return this.service.request({
			method: 'DELETE',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	convertModelToFormData(model, form = null, namespace = '') {
		//Setup
        let formData = form || new FormData();
        let formKey;

        //Check if we are on the first level of an array with a string value
        if(form && namespace != '' && typeof model != 'object')
        {
        	//Check for null
        	if(model != null && model != '')
        	{
        		formData.append(namespace, model);
        	}

        	//Stop Here
        	return;
        }

        for (let propertyName in model)
        {
            //Check for name
            if (!model.hasOwnProperty(propertyName) || model[propertyName] == undefined || model[propertyName] == null) continue;

            //Setup the key
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

            //Build it
            if (model[propertyName] instanceof Date)
            {
                formData.append(formKey, model[propertyName].toISOString());
            }
            else if (model[propertyName] instanceof Array)
            {
                model[propertyName].forEach((element, index) => {
                    //Setup the Temp Key
                    const tempFormKey = `${formKey}[${index}]`;

                    //Recursion
                    this.convertModelToFormData(element, formData, tempFormKey);
                    //formData.append(tempFormKey, element.toString());
                });
            }
            else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            {
                this.convertModelToFormData(model[propertyName], formData, formKey);
            }
            else
            {
                formData.append(formKey, model[propertyName].toString());
            }
        }

        return formData;
    }
}

export default new Api;